import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import type { UserTransformed } from "~pages/Users/PermissionUserListPage/types";
import type { DefaultOperationSuccessResponse } from "~types/response";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";

const useDeletePermissionUser = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, number>({
    mutationFn: async (userId: number) =>
      await request(`${sport}/o/${organizationId}/users/${userId}`, {
        method: "DELETE",
      }),
    onSuccess: (response: DefaultOperationSuccessResponse, userId: number) => {
      if (isDefaultOperationSucceeded(response)) {
        queryClient.setQueryData<UserTransformed[] | undefined>(
          ["permission-users", sport, organizationId],
          (oldData) => oldData?.filter((item: UserTransformed) => item?.userId !== userId) || [],
        );
      }
    },
  });
};

export default useDeletePermissionUser;
